import React from 'react';
import styles from './News.module.css';
// import NewsP  from '../../images/find/image-unavailable.webp';
import Picone from '../../images/News/Avis - Tbilisi Downtown.jpg';
import Driver from '../../images/News/car-credit-insurance.jpeg';
import Avis from '../../images/News/31248860_6087346462500_4226356043849924608_n.jpg';

import { NavLink } from 'react-router-dom';

function News() {
  return (
    <div  className={styles.news}>
      <div className={styles.heading}>
        
        {/* <div className={styles.text_bg}>
          <p>
            <span>
            Rent a Car in Georgia
            </span>
          </p>
        </div> */}
        <h2>News</h2>
      </div>

      <div className={styles.container}>
        <div className={styles.card}>
          <img 
          src={Driver} 
          alt="" />
          <div className={styles.content}>
            <h3>
            <NavLink to='/newsone'>FREE Additional Driver</NavLink>
            </h3>
          </div>
        </div>

        <div className={styles.card}>
          <img 
          src={Picone} 
          alt="" />
          <div className={styles.content}>
            <h3>
            <NavLink to='/newstwo'>2024 WINNER COMPANY</NavLink>
            </h3>
          </div>
        </div>

        <div className={styles.card}>
          <img 
          src={Avis} 
          alt="" />
          <div className={styles.content}>
            <h3>
            <NavLink to='/newsthree'>About Avis </NavLink>
            </h3>
          </div>
        </div>

      </div>
     

      

    </div>
  );
}

export default News;
